import { useState } from "react";
import {
  Form,
  Button,
} from "antd";

import { MdDownload, MdOutlineSearch } from "react-icons/md";
import useModal from "../../hooks/useModal";
import useModalSelecaoTalhoes from "../../hooks/useModalSelecaoTalhoes";
import {
  useGetImportacaoPlanoOperacional,
  useGetUnidadesGEO
} from "../../hooks/useGetImportacaoPlanoOperacional";
import { useFiltersLists } from "core/features/filters/store/lists";
import { FormModal } from "./partials/FormModal";
import { TableListImpot } from "./partials/TableListImpot";
import { useTableListTalhoes } from "../../hooks/useTableListTalhoes";
import { Loader } from "./Loader";
import { CustomModal, Header, Title, ModalContainer } from "./styles";
import { showWarning } from "infra/helpers/alerta";

const { useForm } = Form;

type Props = {
  filtersData: any
};

function ImportModal({ filtersData }: Props) {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = useForm();
    const { isOpenImport, setIsOpenImport } = useModal();
    const { mutateAsync: getImportacaoPlanoOperacional } = useGetImportacaoPlanoOperacional();
    const { mutateAsync: getUnidadesGEO } = useGetUnidadesGEO();
    const { unidades } = useFiltersLists();
    const { setGeoJSON, hasData, setHasData } = useModalSelecaoTalhoes();
    const { addRow, rows, clearRows } = useTableListTalhoes();
    
    function handleClose() {
      setIsOpenImport(false);
      clearRows();
      setHasData(false);
      form.resetFields();
    }

     async function onFinish() {
        const body = form.getFieldsValue();
  
        const payload = {
          IdExternoSafra: body.safra,
          IdExternoOcupacao: body.cultura,
          IdExternoFazenda: body.fazenda,
          IdExternoCenario: body.cenario,
          IdExternoOperacaoClasse: body.classeOperacao,
          IdExternoOperacao: body.operacao,
          CodigoPlanoOperacional: body.codigoPacote,
          IdExternoGrupo: body.grupoPacote,
          IdExternoSubgrupo: body.subgrupoPacote,
        }
  
        try {
          clearRows();
          setIsLoading(true);
          const unid = filtersData?.unidadeList?.find((unid: any) => unid.value === body.fazenda);
        
          let unidadeId = null;
          
          if(unid) {
            const unidSelcted = unidades?.find((unidItem: any) => unid?.text?.includes(unidItem.nome));
            if(unidSelcted) {
              unidadeId = unidSelcted.id;
            }
          }
          
          let { data: response } = await getImportacaoPlanoOperacional(payload);

          if (unidadeId) {
            const { data: responseUnidadeGeo } = await getUnidadesGEO(unidadeId);
            setGeoJSON(responseUnidadeGeo);
          }

          // Metodo temporário para tirar os duplicados
          response = response?.reduce((acc: any, item: any) => {
            if (!acc.some((x: any) => x.idExternoPlanoOperacional === item.idExternoPlanoOperacional)) {
              acc.push(item);
            }
            return acc;
          }, []);

          const newResponse = response?.map((list: any) => ({
            ...list,
            edited: false,
            talhoes: [
              ...list?.talhoes?.filter((talhao: any) => talhao?.talhaoId)?.map((talhao: any) => ({
                ...talhao,
                checked: true
              })),
              ...list?.talhoes?.filter((talhao: any) => !talhao?.talhaoId)
            ]
          }));
          
          addRow(newResponse);
          setHasData(true);
          setIsLoading(false);
        } catch (error) {
          showWarning("Não foram encontrados planos no GEO Agrícola com os filtros informados.", "Não há dados");
          setIsLoading(false);
        }
      }

    return (
    <CustomModal
      title={
        <Header>
          <MdDownload  size={28} />
          Importar Planejamentos do GeoAgrícola
        </Header>
      }
      visible={isOpenImport}
      width={"95%"}
      onCancel={handleClose}
      maskClosable={false}
      centered
      getContainer={document.body}
      footer={
        <>
          <Button
            size="large"
            onClick={!hasData ? handleClose : () => setHasData(false)}
            style={{ borderRadius: 8 }}
          >{!hasData ? "Cancelar" : "Voltar"}</Button>
          {!hasData && (
            <Button
            size="large"
            type="primary"
            onClick={() => form.submit()}
            style={{ 
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              gap: 8, 
              float: "right",
              backgroundColor: "#12619C"
            }}
            icon={<MdOutlineSearch size={23} />}
          >  Buscar</Button>
          )}
        </>
      }
      modalRender={(dom) => (
        <div style={{ position: "relative" }}>
          {isLoading && <Loader />}
          {dom}
        </div>
      )}
    >

      <ModalContainer>
        {!hasData ? (
          <>
              <Title>
                Filtros de Busca
              </Title>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
              >
                <FormModal filtersData={filtersData} form={form} />
                </Form>
          </>
        ) : <TableListImpot listItem={rows} />}
     
      </ModalContainer>
      
    </CustomModal>
    )
}

export default ImportModal;